import { mapState } from 'pinia';
import stores from 'store/modules';

export default {
    computed: {
        ...mapState(stores.User, ['loadingMain']),
        ...mapState(stores.Organization, ['organization']),
    },

    watch: {
        async isLoadingEcho(status) {
            if (status) return;

            this.initOrganizationEcho();
        },
    },

    methods: {
        initOrganizationEcho() {
            if (!this.organization?.id) return;
            if (!this.$echo) return;

            this.resetOrganizationEcho();

            this.$echo
                .join(`organization.${this.organization.id}`)
                .listen('.account_balance.updated', this.echoAccountBalanceUpdated)
                .listen('.subscription.updated', this.echoSubscriptionUpdated)
                .listen('.subscription.upgraded', this.echoSubscriptionUpgraded)
                .listen('.contact.created', this.echoContactCreated)
                .listen('.contact.updated', this.echoContactUpdated)
                .listen('.contact.deleted', this.echoContactDeleted)
                .listen('.contacts.deleted', this.echoContactsDeleted)
                .listen('.autorecharge.failed', this.echoAutorechargeFailed)
                .listen('.custom_field.deleted', this.echoCustomFieldRemove)
                .listen('.custom_field.updated', this.echoCustomFieldUpdate)
                .listen('.custom_field.created', this.echoCustomFieldAdd)
                .listen('.dlc.info', this.echoDlsLimits)
                .listen('.seats.updated', this.echoSeatsUpdated)
                .listen(
                    '.organization.restriction.removed',
                    this.echoOrganizationRestrictionRemoved
                );
        },

        resetOrganizationEcho() {
            if (!this.organization?.id) return;
            if (!this.$echo) return;

            this.$echo
                .join(`organization.${this.organization.id}`)
                .stopListening('.account_balance.updated')
                .stopListening('.subscription.updated')
                .stopListening('.subscription.upgraded')
                .stopListening('.contact.created')
                .stopListening('.contact.updated')
                .stopListening('.contact.deleted')
                .stopListening('.contacts.deleted')
                .stopListening('.autorecharge.failed')
                .stopListening('.custom_field.deleted')
                .stopListening('.custom_field.updated')
                .stopListening('.custom_field.created')
                .stopListening('.dlc.info')
                .stopListening('.seats.updated')
                .stopListening('.organization.restriction.removed');

            this.$echo.leave(`organization.${this.organization.id}`);
        },

        echoSeatsUpdated(e) {
            this.$store.dispatch('subscriptionUpdated', {
                seats: e,
            });
        },

        echoOrganizationRestrictionRemoved(e) {
            this.$store.dispatch('updateOrganizationIsNumbersGracePeriod', false);
        },

        echoDlsLimits(e) {
            this.$store.dispatch('updateDlcLimits', e);
        },

        echoAutorechargeFailed(e) {
            const failure = e.autoRecharge.failure ? false : true;

            this.$store.dispatch('clearAutorechargeFailure', {
                status: failure,
                cookie: this.$cookie,
                data: e.autoRecharge,
            });
        },

        echoAccountBalanceUpdated(e) {
            this.$store.dispatch('accountBalanceUpdated', e);
        },

        echoSubscriptionUpdated(e) {
            this.$store.dispatch('subscriptionUpdated', e);
        },

        echoSubscriptionUpgraded(e) {
            this.$store.dispatch('subscriptionUpgraded', e);
        },

        echoContactCreated(e) {
            this.$store.dispatch('contactCreated', e);
        },

        echoContactUpdated(e) {
            this.$store.dispatch('contactUpdated', e);
            this.$rootEvents.$emit('contactUpdated', e);
        },

        echoContactDeleted(e) {
            this.$store.dispatch('contactDeleted', e);
            this.$rootEvents.$emit('contactDeleted', e.id);
        },

        echoContactsDeleted(e) {
            this.$store.dispatch('contactsDeleted', e);
            this.$rootEvents.$emit('contactsDeleted', e);
        },

        echoCustomFieldRemove(e) {
            this.$store.dispatch('customFieldRemove', e.customField);
        },

        echoCustomFieldUpdate(e) {
            this.$store.dispatch('customFieldUpdate', e.customField);
        },

        echoCustomFieldAdd(e) {
            this.$store.dispatch('customFieldAdd', e.customField);
        },
    },
};
